import { useContext ,useEffect, useState} from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import no_image_available from "../../assets/images/no_image_available.png";
import UnavailableBookingDayCalendar from "./components/UnavailableBookingDayCalendar";
import { tripUnavailableDateService } from "../../services/tripUnavailableDateService";
import { tripService } from "../../services/tripService";
import Loading from "../../components/common/Loading";
import BackButton from "../../components/common/BackButton";
import { toast } from "../../services/toastService";
import { useParams } from "react-router-dom";
import { urlConfig } from "../../config/baseUrl";

  const UnavailableBookingDay = () => {
  const { t,lang } = useContext(LocaleContext);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const {tripId}=useParams();

  useEffect(()=>{
    window.scrollTo(0, 0);
    getAsync();
  },[]);

  const getAsync=async ()=>{
    try {
      setLoading(true);
      var response=await tripService.getTripUnavailableDatesAsync(tripId);
      if (!response.isSuccess) {
        toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        console.log(response);
        return;
      }
      console.log(response);

      setData(response.value);
    } catch (error) {
       toast.error(t("anErrorOccurredPleaseTryAgainLater"));
      console.log(error)
    }
    finally{
      setLoading(false);
    }
  }

  if(loading) return <Loading/>

  return (
    <section className="today-closed-bookings">
      <div className="default-heading">{t("tripsDashboardAndManagement")}</div>
      <div className="my-card">
        <div className="my-card-header d-flex justify-content-between align-items-center">
          {t("calender")}
          <BackButton />
        </div>
        <div className="trip-card mt-3">
          <div className="row">
            <div className="col-12 col-md-4">
              <div className="trip-provider-information">
                <div className="trip-provider-profile-layer">
                  <div className="trip-provider-profile">
                    <img src={`${urlConfig.imageBaseUrl}/${data?.profile}` || no_image_available} alt="Provider Profile" />
                  </div>
                </div>
                <b>
                  <i className="fas fa-images"></i> {t("edit")}
                </b>
              </div>
            </div>
            <div className="col-12 col-md-8">
              <div className="row h-100">
                <div className="col-12 col-md-12">
                  <div className="trip-provider-items">
                    <div className="trip-provider-item">
                      <strong>{t("providerName")}</strong>
                      <span>{data?.providerName}</span>
                    </div>
                    <div className="trip-provider-item">
                      <strong>{t("trip")}</strong>
                      <span>{data?.tripTitle?.[lang]}</span>
                    </div>
                    <div className="trip-provider-item">
                      <strong>{t("code")}</strong>
                      <span>{data?.code}</span>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="trip-provider-items border-0">
                    <div className="trip-provider-item">
                      <strong>{t("city")}</strong>
                      <span>{data?.city?.[lang]}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="trip-card mt-3 flex-center">
          <UnavailableBookingDayCalendar
              t={t}
              tripId={tripId}
            />
        </div>
      </div>
    </section>
  );
};

export default UnavailableBookingDay;
